var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 5.9763V11.4043C14.6674 11.9577 14.4556 12.4902 14.0755 12.8925C13.6955 13.2947 13.1759 13.5363 12.6233 13.5676L12.5007 13.571H3.50065C2.94723 13.571 2.41477 13.3593 2.0125 12.9792C1.61023 12.5991 1.36865 12.0795 1.33732 11.527L1.33398 11.4043V5.9763L7.76865 9.34696C7.84024 9.38446 7.91984 9.40405 8.00065 9.40405C8.08146 9.40405 8.16107 9.38446 8.23265 9.34696L14.6673 5.9763ZM3.50065 2.9043H12.5007C13.0377 2.90423 13.5556 3.10363 13.954 3.46381C14.3524 3.82399 14.6028 4.31928 14.6566 4.85363L8.00065 8.3403L1.34465 4.85363C1.39633 4.34051 1.62935 3.86264 2.00182 3.50594C2.37428 3.14924 2.86177 2.93709 3.37665 2.90763L3.50065 2.9043Z",
    fill: "#725CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.1075643140070f647bf7d252ac838f79.svg";
export { ForwardRef as ReactComponent };